var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _path11, _path12, _path13, _path14, _g7, _path15, _g8, _path16, _g9, _path17, _path18, _path19, _g10, _path20, _g11, _path21, _g12, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide6Ill1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 220,
    viewBox: "0 0 359 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.709 128.786L358.888 142.661V69.3604L337.709 79.1582V128.786Z",
    fill: "url(#paint0_linear_7761_85349)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.03 184.953V185.3L317.768 198.987V21.4382L341.03 32.8493C346.404 32.8493 350.734 66.8943 350.734 108.901C350.734 150.908 346.374 184.953 341.03 184.953Z",
    fill: "url(#paint1_linear_7761_85349)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.03 184.95V185.296L317.768 198.984V21.4348L341.03 32.8458C346.404 32.8458 350.734 66.8909 350.734 108.898C350.734 150.905 346.374 184.95 341.03 184.95Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.592 41.7601L368.781 52.0973V-9.25806H324.592V41.7601Z",
    fill: "url(#paint2_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341.03 184.95V185.296L317.768 198.984V21.4348L341.03 32.8458C346.404 32.8458 350.734 66.8909 350.734 108.898C350.734 150.905 346.374 184.95 341.03 184.95Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.201 143.288L352.219 137.345V69.6063L323.201 64.9004V143.288Z",
    fill: "url(#paint3_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 21,
    width: 34,
    height: 178
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.03 184.95V185.296L317.768 198.984V21.4348L341.03 32.8458C346.404 32.8458 350.734 66.8909 350.734 108.898C350.734 150.905 346.374 184.95 341.03 184.95Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.151 220.735H355.193L352.471 171.142L324.151 178.758V220.735Z",
    fill: "url(#paint4_linear_7761_85349)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.527 219.914H295.607V0.961426H321.527C328.544 0.961426 334.235 49.9853 334.235 110.425C334.235 170.865 328.544 219.919 321.527 219.919V219.914Z",
    fill: "url(#paint5_linear_7761_85349)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M321.527 219.912H295.607V0.959717H321.527C328.544 0.959717 334.235 49.9836 334.235 110.423C334.235 170.863 328.544 219.917 321.527 219.917V219.912Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.228 55.1633H304.268V150.212H350.228V55.1633Z",
    fill: "url(#paint6_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M321.527 219.912H295.607V0.959717H321.527C328.544 0.959717 334.235 49.9836 334.235 110.423C334.235 170.863 328.544 219.917 321.527 219.917V219.912Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M340.618 -84.6418H294.657V10.4072H340.618V-84.6418Z",
    fill: "url(#paint7_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 0,
    width: 40,
    height: 220
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.527 219.912H295.607V0.959717H321.527C328.544 0.959717 334.235 49.9836 334.235 110.423C334.235 170.863 328.544 219.917 321.527 219.917V219.912Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M337.9 187.549H291.939V317.049H337.9V187.549Z",
    fill: "url(#paint8_linear_7761_85349)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.608 219.917C302.626 219.917 308.315 170.908 308.315 110.453C308.315 49.9976 302.626 0.989014 295.608 0.989014C288.59 0.989014 282.9 49.9976 282.9 110.453C282.9 170.908 288.59 219.917 295.608 219.917Z",
    fill: "url(#paint9_linear_7761_85349)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.065 10.1284H59.8662V215.364H292.065C299.082 215.364 304.773 169.403 304.773 112.729C304.773 56.0546 299.082 10.1284 292.065 10.1284Z",
    fill: "url(#paint10_linear_7761_85349)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7091 195.734H299.527C299.527 195.734 296.87 212.36 292.634 215.364H67.7041V195.734H67.7091Z",
    fill: "url(#paint11_linear_7761_85349)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3153 0.957346H48.3955V219.91H74.3153C81.3321 219.91 87.0228 170.886 87.0228 110.446C87.0228 50.006 81.3321 0.952393 74.3153 0.952393V0.957346Z",
    fill: "url(#paint12_linear_7761_85349)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3163 0.956125H48.3965V219.908H74.3163C81.3331 219.908 87.0238 170.885 87.0238 110.445C87.0238 50.0048 81.3331 0.951172 74.3163 0.951172V0.956125Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.5897 58.3594H49.6289V153.408H95.5897V58.3594Z",
    fill: "url(#paint13_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3163 0.956125H48.3965V219.908H74.3163C81.3331 219.908 87.0238 170.885 87.0238 110.445C87.0238 50.0048 81.3331 0.951172 74.3163 0.951172V0.956125Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.0136 -81.4441H40.0527V13.6049H86.0136V-81.4441Z",
    fill: "url(#paint14_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 40,
    height: 220
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3163 0.956125H48.3965V219.908H74.3163C81.3331 219.908 87.0238 170.885 87.0238 110.445C87.0238 50.0048 81.3331 0.951172 74.3163 0.951172V0.956125Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.1112 190.767H46.1504V320.267H92.1112V190.767Z",
    fill: "url(#paint15_linear_7761_85349)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.395 219.917C55.4132 219.917 61.1025 170.908 61.1025 110.453C61.1025 49.9976 55.4132 0.989014 48.395 0.989014C41.3769 0.989014 35.6875 49.9976 35.6875 110.453C35.6875 170.908 41.3769 219.917 48.395 219.917Z",
    fill: "url(#paint16_linear_7761_85349)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9809 23.1479L26.0137 32.8221V185.273L43.7785 195.734C48.425 195.734 54.1157 151.45 54.1157 109.443C54.1157 67.4362 49.5978 23.1529 44.9809 23.1529V23.1479Z",
    fill: "url(#paint17_linear_7761_85349)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9809 23.147L26.0137 32.8211V185.272L43.7785 195.733C48.425 195.733 54.1157 151.449 54.1157 109.442C54.1157 67.4352 49.5978 23.1519 44.9809 23.1519V23.147Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.2635 36.4589L9.07422 46.7912V-14.5889H53.2635V36.4589Z",
    fill: "url(#paint18_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9809 23.147L26.0137 32.8211V185.272L43.7785 195.733C48.425 195.733 54.1157 151.449 54.1157 109.442C54.1157 67.4352 49.5978 23.1519 44.9809 23.1519V23.147Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.1497 153.411L28.1025 147.468V79.7293L57.1497 74.9888V153.411Z",
    fill: "url(#paint19_linear_7761_85349)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_7761_85349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 29,
    height: 173
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9809 23.147L26.0137 32.8211V185.272L43.7785 195.733C48.425 195.733 54.1157 151.449 54.1157 109.442C54.1157 67.4352 49.5978 23.1519 44.9809 23.1519V23.147Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_7761_85349)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.3606 225.729H17.3242L20.0409 176.136L48.3606 183.752V225.729Z",
    fill: "url(#paint20_linear_7761_85349)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M44.981 23.1484L33.664 28.9331C34.8961 34.0547 36.633 39.1417 37.1081 44.2633C40.5868 84.4691 43.7439 123.631 38.0582 164.188C36.92 172.754 33.7926 180.246 31.165 188.336L43.7439 195.734C48.3905 195.734 54.0811 151.451 54.0811 109.444C54.0811 67.4367 49.5929 23.1534 44.9761 23.1534L44.981 23.1484Z",
    fill: "url(#paint21_linear_7761_85349)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9843 185.271C29.8077 185.271 32.9072 151.15 32.9072 109.061C32.9072 66.9707 29.8077 32.8501 25.9843 32.8501C22.161 32.8501 19.0615 66.9707 19.0615 109.061C19.0615 151.15 22.161 185.271 25.9843 185.271Z",
    fill: "url(#paint22_linear_7761_85349)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3713 108.27C24.3713 120.25 25.8558 130.681 24.6237 132.987C24.4356 133.304 21.8427 133.081 21.6546 133.081C20.1355 133.081 18.9033 121.987 18.9033 108.27C18.9033 94.5527 20.1355 83.4584 21.6546 83.4584C21.8427 83.4584 24.213 83.1417 24.4059 83.4584C25.6381 85.799 24.3763 96.2896 24.3763 108.27H24.3713Z",
    fill: "url(#paint23_linear_7761_85349)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3714 133.08C25.8909 133.08 27.1227 121.972 27.1227 108.269C27.1227 94.5659 25.8909 83.4575 24.3714 83.4575C22.8519 83.4575 21.6201 94.5659 21.6201 108.269C21.6201 121.972 22.8519 133.08 24.3714 133.08Z",
    fill: "url(#paint24_linear_7761_85349)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3709 83.4587L0 59.3748V153.409L24.3709 133.086V83.4587Z",
    fill: "url(#paint25_linear_7761_85349)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.7973 208.188C49.0353 208.188 50.0389 205.824 50.0389 202.908C50.0389 199.992 49.0353 197.628 47.7973 197.628C46.5593 197.628 45.5557 199.992 45.5557 202.908C45.5557 205.824 46.5593 208.188 47.7973 208.188Z",
    fill: "url(#paint26_linear_7761_85349)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.6447 139.915C57.3444 139.915 57.9115 137.551 57.9115 134.635C57.9115 131.719 57.3444 129.355 56.6447 129.355C55.9451 129.355 55.3779 131.719 55.3779 134.635C55.3779 137.551 55.9451 139.915 56.6447 139.915Z",
    fill: "url(#paint27_linear_7761_85349)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.383 69.929C56.0826 69.929 56.6498 67.5651 56.6498 64.6491C56.6498 61.733 56.0826 59.3691 55.383 59.3691C54.6834 59.3691 54.1162 61.733 54.1162 64.6491C54.1162 67.5651 54.6834 69.929 55.383 69.929Z",
    fill: "url(#paint28_linear_7761_85349)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.0891 21.5079C46.7887 21.5079 47.3558 19.144 47.3558 16.2279C47.3558 13.3119 46.7887 10.948 46.0891 10.948C45.3894 10.948 44.8223 13.3119 44.8223 16.2279C44.8223 19.144 45.3894 21.5079 46.0891 21.5079Z",
    fill: "url(#paint29_linear_7761_85349)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7761_85349",
    x1: 351.096,
    y1: 101.008,
    x2: 329.877,
    y2: 101.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD2E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7761_85349",
    x1: 336.399,
    y1: -4.98686,
    x2: 334.663,
    y2: 170.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7761_85349",
    x1: 338.876,
    y1: -24.2515,
    x2: 338.876,
    y2: 52.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7761_85349",
    x1: 329.882,
    y1: 46.1204,
    x2: 329.882,
    y2: 144.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7761_85349",
    x1: 331.845,
    y1: 159.234,
    x2: 331.845,
    y2: 221.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7761_85349",
    x1: 315.417,
    y1: 218.304,
    x2: 315.417,
    y2: -9.62085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7761_85349",
    x1: 328.68,
    y1: 53.0512,
    x2: 328.68,
    y2: 151.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7761_85349",
    x1: 319.052,
    y1: -87.0254,
    x2: 319.052,
    y2: 11.9111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7761_85349",
    x1: 316.327,
    y1: 185.212,
    x2: 316.327,
    y2: 320.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7761_85349",
    x1: 269.628,
    y1: 109.844,
    x2: 308.592,
    y2: 109.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303256",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2A3861",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#224272",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1D487C",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7761_85349",
    x1: 183.474,
    y1: 9.61834,
    x2: 183.474,
    y2: 213.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD2E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7761_85349",
    x1: 184.772,
    y1: 215.789,
    x2: 184.772,
    y2: 195.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD2E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7761_85349",
    x1: 68.6392,
    y1: -3.0481,
    x2: 68.6392,
    y2: 224.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7761_85349",
    x1: 73.5493,
    y1: 56.2763,
    x2: 73.5493,
    y2: 155.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7761_85349",
    x1: 63.9524,
    y1: -83.8067,
    x2: 63.9524,
    y2: 15.1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7761_85349",
    x1: 70.0659,
    y1: 188.426,
    x2: 70.0659,
    y2: 323.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7761_85349",
    x1: 35.2904,
    y1: 207.045,
    x2: 61.1647,
    y2: 27.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#95AAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BBC8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C2CEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7761_85349",
    x1: 40.9438,
    y1: -17.3863,
    x2: 40.9438,
    y2: 199.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7761_85349",
    x1: 32.0277,
    y1: -29.5825,
    x2: 32.0277,
    y2: 47.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7761_85349",
    x1: 43.5097,
    y1: 56.2537,
    x2: 43.5097,
    y2: 154.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7761_85349",
    x1: 33.7072,
    y1: 164.242,
    x2: 33.7072,
    y2: 226.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7761_85349",
    x1: 32.0288,
    y1: 108.831,
    x2: 54.9894,
    y2: 108.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#678ADC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00112C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7761_85349",
    x1: 14.9211,
    y1: 196.545,
    x2: 38.6798,
    y2: 20.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7761_85349",
    x1: 19.6685,
    y1: 136.541,
    x2: 27.4752,
    y2: 78.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7761_85349",
    x1: 21.3377,
    y1: 136.353,
    x2: 29.0778,
    y2: 79.1417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7761_85349",
    x1: 0.802434,
    y1: 105.774,
    x2: 27.5349,
    y2: 105.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FBE6D6",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E5D8",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DDE2DA",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C2DDDE",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A0D8E2",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7761_85349",
    x1: 46.4298,
    y1: 202.494,
    x2: 50.8984,
    y2: 202.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7761_85349",
    x1: 56.2787,
    y1: 134.081,
    x2: 58.825,
    y2: 134.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7761_85349",
    x1: 55.0026,
    y1: 63.9628,
    x2: 57.5488,
    y2: 63.9438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7761_85349",
    x1: 45.7098,
    y1: 15.4406,
    x2: 48.2561,
    y2: 15.4247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#869FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1B4A7F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide6Ill1);
export default __webpack_public_path__ + "static/media/slide_6_ill_1.0385f521e9792327d700604d30ea1360.svg";
export { ForwardRef as ReactComponent };